import React from "react";
import PropTypes from "prop-types";

//
import NumberFormat from "react-number-format";

function AssetInfo({ symbol, quantity, avgPrice, benefit, benefitPercent }) {
  return (
    <div className="asset-info">
      <div className="item">
        <p className="fw-extra-bolder text-black">Quantity</p>
        <small className="fw-bolder">
          {quantity} {symbol}
        </small>
      </div>

      <div className="item">
        <p className="fw-extra-bolder text-black">Avg. buy price</p>
        <div>
          <small className="fw-bolder">
            <NumberFormat
              value={Number(avgPrice.USDT)
                .toFixed(symbol === "BTC" ? 2 : 8)
                .replace(/\.?0+$/, "")}
              displayType={"text"}
              prefix="$"
              thousandSeparator={true}
              decimalSeparator="."
            />
          </small>
          <small className="fw-bolder">
            <NumberFormat
              value={Number(avgPrice.BTC)
                .toFixed(symbol === "BTC" ? 2 : 8)
                .replace(/\.?0+$/, "")}
              displayType={"text"}
              prefix="₿"
              thousandSeparator={true}
              decimalSeparator="."
            />
          </small>
        </div>
      </div>

      <div className="item">
        <p className="fw-extra-bolder text-black">Profit / Loss</p>
        <div>
          <div className="d-flex">
            <small
              className={`fw-bolder ${
                +benefitPercent.USDT > 0 ? "text-success" : "text-danger"
              }`}
            >
              {+benefitPercent.USDT > 0 && "+"}
              {benefitPercent.USDT}%
            </small>

            <small
              className={`fw-bolder ${
                +benefit.USDT > 0 ? "text-success" : "text-danger"
              }`}
            >
              ({+benefit.USDT > 0 && "+ "}${benefit.USDT})
            </small>
          </div>

          <div className="d-flex">
            <small
              className={`fw-bolder ${
                +benefitPercent.BTC > 0 ? "text-success" : "text-danger"
              }`}
            >
              {+benefitPercent.BTC > 0 && "+"}
              {benefitPercent.BTC}%
            </small>

            <small
              className={`fw-bolder ${
                +benefit.BTC > 0 ? "text-success" : "text-danger"
              }`}
            >
              ({+benefit.BTC > 0 && "+ "}${benefit.BTC})
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}

AssetInfo.propTypes = {};

export default AssetInfo;
